export const PORTFOLIO_UPLOAD_COLUMNS = [
  // Individual KYC
  { key: "first_name", label: "First Name", required: true, section: "Individual KYC" },
  { key: "last_name", label: "Last Name", required: true, section: "Individual KYC" },
  { key: "ghana_card_number", label: "Ghana Card Number", required: true, section: "Individual KYC" },
  { key: "gender", label: "Gender", required: true, section: "Individual KYC" },
  { key: "date_of_birth", label: "Date of Birth", required: true, section: "Individual KYC" },
  { key: "customer_number", label: "Phone Number", required: true, section: "Individual KYC" },
  { key: "phone", label: "Mobile Number", required: true, section: "Individual KYC" },
  { key: "email", label: "Email", required: false, section: "Individual KYC" },
  { key: "country", label: "Country", required: true, section: "Individual KYC" },
  { key: "region", label: "Region", required: true, section: "Individual KYC" },
  { key: "exact_area", label: "Exact Area", required: true, section: "Individual KYC" },
  { key: "gps_address", label: "GPS Address", required: false, section: "Individual KYC" },
  // KYC on loan taken
  { key: "account_number", label: "Account Number", required: true, section: "Loan KYC" },
  { key: "loan_amount", label: "Loan Amount", required: true, section: "Loan KYC" },
  { key: "due_date", label: "Due Date", required: true, section: "Loan KYC" },
  // KYC on payment
  { key: "last_payment_date", label: "Last Payment Date", required: false, section: "Payment KYC" },
  { key: "amount_paid", label: "Amount Paid", required: false, section: "Payment KYC" },
  { key: "outstanding_balance", label: "Outstanding Balance", required: true, section: "Payment KYC" },
];

export const PORTFOLIO_GENDERS = ["Male", "Female", "Other"];

/** Legacy alias — older templates used “Current Balance or Arrears” */
export const LEGACY_OUTSTANDING_AMOUNT_COLUMN = {
  key: "outstanding_amount",
  label: "Current Balance or Arrears",
  required: false,
};

/** Legacy column — only used when parsing old templates that include portfolio name */
export const LEGACY_PORTFOLIO_NAME_COLUMN = {
  key: "portfolio_name",
  label: "Portfolio Name",
  required: false,
};

export const SEGMENTS = [
  "Early stage (1–30 days)",
  "Mid stage (31–60 days)",
  "Late stage (61–90 days)",
  "Critical (90+ days)",
  "High value",
  "Repeat defaulter",
];

export const RISK_LEVELS = ["Low", "Medium", "High"];
export const PRIORITY_TIERS = ["Standard", "Priority", "Urgent"];
export const REPAYMENT_BEHAVIORS = ["Good payer", "Fair", "Poor", "First default"];

/** Plain-English debt status shown on customer records */
export const DEBT_STATUSES = [
  { value: "active", label: "Early stage" },
  { value: "pending", label: "At risk" },
  { value: "overdue", label: "Overdue" },
];

export function getDebtStatusLabel(status) {
  return DEBT_STATUSES.find((s) => s.value === status)?.label ?? status;
}

export const MOCK_PORTFOLIO_GROUPS = [
  {
    id: "GRP-001",
    name: "Q1 2026 Retail",
    description: "Retail overdue accounts — first quarter recovery book",
    color: "primary",
    createdAt: "2026-01-10",
    uploads: [
      {
        id: "UPL-001",
        fileName: "q1_retail_jan.xlsx",
        accounts: 342,
        totalOwed: 1840000,
        uploadedAt: "2026-02-18",
        status: "completed",
        stage: "cases_created",
        casesCreated: 342,
        validationPassRate: 98.2,
        invalidRows: 6,
      },
      {
        id: "UPL-002",
        fileName: "q1_retail_feb.xlsx",
        accounts: 86,
        totalOwed: 415000,
        uploadedAt: "2026-02-05",
        status: "processing",
        stage: "processing",
        casesCreated: 52,
        validationPassRate: 96.5,
        invalidRows: 3,
      },
    ],
  },
  {
    id: "GRP-002",
    name: "SME Recovery",
    description: "Small business loans and overdrafts",
    color: "accent",
    createdAt: "2026-01-22",
    uploads: [
      {
        id: "UPL-003",
        fileName: "sme_batch_feb.xlsx",
        accounts: 128,
        totalOwed: 920000,
        uploadedAt: "2026-02-10",
        status: "completed",
        stage: "cases_created",
        casesCreated: 128,
        validationPassRate: 100,
        invalidRows: 0,
      },
    ],
  },
  {
    id: "GRP-003",
    name: "Agri & Rural",
    description: "Agricultural and rural lending portfolio",
    color: "emerald",
    createdAt: "2026-02-01",
    uploads: [
      {
        id: "UPL-004",
        fileName: "agri_dec2025.xlsx",
        accounts: 210,
        totalOwed: 680000,
        uploadedAt: "2025-12-20",
        status: "completed",
        stage: "cases_created",
        casesCreated: 210,
        validationPassRate: 99.1,
        invalidRows: 2,
      },
    ],
  },
  {
    id: "GRP-004",
    name: "Payroll Deduction",
    description: "Staff and payroll-linked facilities",
    color: "primary",
    createdAt: "2026-02-08",
    uploads: [
      {
        id: "UPL-005",
        fileName: "payroll_jan.xlsx",
        accounts: 64,
        totalOwed: 210000,
        uploadedAt: "2026-02-12",
        status: "completed",
        stage: "cases_created",
        casesCreated: 64,
        validationPassRate: 100,
        invalidRows: 0,
      },
    ],
  },
  {
    id: "GRP-005",
    name: "Write-off Review",
    description: "Accounts under write-off consideration",
    color: "accent",
    createdAt: "2026-02-14",
    uploads: [],
  },
  {
    id: "GRP-006",
    name: "High Value Book",
    description: "Accounts above GHS 50,000 outstanding",
    color: "emerald",
    createdAt: "2026-02-20",
    uploads: [
      {
        id: "UPL-006",
        fileName: "high_value_feb.xlsx",
        accounts: 28,
        totalOwed: 2450000,
        uploadedAt: "2026-02-21",
        status: "completed",
        stage: "validated",
        casesCreated: 0,
        validationPassRate: 92.5,
        invalidRows: 2,
      },
      {
        id: "UPL-007",
        fileName: "high_value_topup.xlsx",
        accounts: 11,
        totalOwed: 890000,
        uploadedAt: "2026-02-25",
        status: "processing",
        stage: "processing",
        casesCreated: 4,
        validationPassRate: 100,
        invalidRows: 0,
      },
    ],
  },
];

const DEBTOR_NAMES = [
  "Kofi Mensah", "Ama Serwaa", "Efua Boateng", "Yaw Asante", "Abena Osei",
  "Kwame Appiah", "Akua Darko", "Fiifi Annan", "Maame Adjei", "Kojo Owusu",
];

/** Deterministic mock for cumulative payments against an owed balance */
export function mockAmountPaid(seed, amountOwed) {
  if (amountOwed <= 0) return 0;
  const rates = [0, 0.1, 0.24, 0.38, 0.52, 0.65, 0.78, 0.91];
  return Math.round(amountOwed * rates[seed % rates.length]);
}

/** Generate deterministic account rows for an upload (used for mock data & previews) */
export function generateUploadRecords(count, uploadId, groupName) {
  const seed = uploadId.split("").reduce((s, c) => s + c.charCodeAt(0), 0);
  return Array.from({ length: count }, (_, i) => {
    const n = seed + i * 137;
    const amountOwed = Math.round(2500 + (n * 1837) % 45000);
    const customerPhone = `024${String(1000000 + ((n * 17) % 9000000)).slice(0, 7)}`;
    const mobilePhone = `024${String(1000000 + ((n * 13) % 9000000)).slice(0, 7)}`;
    return {
      id: `${uploadId}-${String(i + 1).padStart(4, "0")}`,
      customer_number: customerPhone,
      customer_name: DEBTOR_NAMES[i % DEBTOR_NAMES.length],
      account_number: `ACC-${uploadId.replace(/\D/g, "").slice(-4)}${2026000 + i}`,
      phone: mobilePhone,
      outstanding_amount: amountOwed,
      amount_owed: amountOwed,
      amount_paid: 0,
      outstanding: amountOwed,
      due_date: new Date(Date.now() - ((n * 3) % 120) * 86400000).toISOString().slice(0, 10),
      group_name: groupName,
      case_id: `RC-${8800 + (i % 900)}`,
    };
  });
}

/** @deprecated Use MOCK_PORTFOLIO_GROUPS — kept for backward compatibility */
export const MOCK_PORTFOLIOS = MOCK_PORTFOLIO_GROUPS.flatMap((g) =>
  g.uploads.map((u) => ({
    id: u.id,
    name: g.name,
    groupId: g.id,
    accounts: u.accounts,
    totalOwed: u.totalOwed,
    uploadedAt: u.uploadedAt,
    status: u.status,
    stage: u.stage,
    uploadedBy: "Acme Rural Bank",
    casesCreated: u.casesCreated,
    validationPassRate: u.validationPassRate,
    invalidRows: u.invalidRows,
  }))
);

export const MOCK_CUSTOMERS = Array.from({ length: 47 }, (_, i) => {
  const names = [
    "Kofi Mensah", "Ama Serwaa", "Efua Boateng", "Yaw Asante", "Abena Osei",
    "Kwame Appiah", "Akua Darko", "Fiifi Annan", "Maame Adjei", "Kojo Owusu",
  ];
  const regions = ["Greater Accra", "Ashanti", "Western", "Eastern", "Northern"];
  const daysOverdue = [12, 28, 45, 67, 92, 15, 33, 8, 51, 74][i % 10];
  const segment =
    daysOverdue > 90
      ? "Critical (90+ days)"
      : daysOverdue > 60
        ? "Late stage (61–90 days)"
        : daysOverdue > 30
          ? "Mid stage (31–60 days)"
          : i % 7 === 0
            ? "High value"
            : i % 11 === 0
              ? "Repeat defaulter"
              : "Early stage (1–30 days)";

  const amountOwed = Math.round(2500 + (i * 1837) % 45000);
  const amountPaid = mockAmountPaid(i, amountOwed);

  return {
    id: `CU-${String(1001 + i).padStart(4, "0")}`,
    name: names[i % names.length],
    phone: `024${String(1000000 + i * 137).slice(0, 7)}`,
    accountNumber: `ACC-${2026000 + i}`,
    amountOwed,
    amountPaid,
    outstanding: Math.max(0, amountOwed - amountPaid),
    daysOverdue,
    region: regions[i % regions.length],
    status: daysOverdue > 60 ? "overdue" : daysOverdue > 30 ? "pending" : "active",
    lastContact: ["SMS", "WhatsApp", "Email", "Phone call"][i % 4],
    riskLevel: daysOverdue > 60 ? "High" : daysOverdue > 30 ? "Medium" : "Low",
    priorityTier: daysOverdue > 90 ? "Urgent" : daysOverdue > 45 ? "Priority" : "Standard",
    repaymentBehavior: REPAYMENT_BEHAVIORS[i % 4],
    segment,
    portfolioId: MOCK_PORTFOLIOS[i % MOCK_PORTFOLIOS.length].id,
  };
});

export const MOCK_CASES = Array.from({ length: 38 }, (_, i) => {
  const customer = MOCK_CUSTOMERS[i % MOCK_CUSTOMERS.length];
  const status = ["open", "pending", "active", "closed"][i % 4];
  const uploadedAt = new Date();
  uploadedAt.setHours(0, 0, 0, 0);
  uploadedAt.setDate(uploadedAt.getDate() - customer.daysOverdue);
  const assignedAgent = ["Grace Mensah", "Samuel Tetteh", null, null][i % 4];
  const assignedAt = assignedAgent
    ? `2026-02-${String(10 + (i % 15)).padStart(2, "0")}`
    : null;
  const reassignedAt =
    assignedAgent && i % 5 === 0 ? `2026-02-${String(18 + (i % 8)).padStart(2, "0")}` : null;
  const closedAt = status === "closed" ? `2026-02-${String(20 - (i % 10)).padStart(2, "0")}` : null;
  const lastActivityAt =
    closedAt ||
    reassignedAt ||
    assignedAt ||
    `2026-02-${String(27 - (i % 20)).padStart(2, "0")}`;

  return {
    id: `RC-${8800 + i}`,
    customer: customer.name,
    amountOwed: customer.amountOwed,
    amountPaid: customer.amountPaid,
    amount: customer.amountOwed,
    uploadedAt: uploadedAt.toISOString().slice(0, 10),
    dueDate: uploadedAt.toISOString().slice(0, 10),
    daysOverdue: customer.daysOverdue,
    channel: ["SMS", "WhatsApp", "Email", "Phone call"][i % 4],
    status,
    assigned: assignedAgent ?? "Unassigned",
    assignedAgent,
    assignedAt,
    reassignedAt,
    lastActivityAt,
    updatedAt: lastActivityAt,
    portfolioId: customer.portfolioId,
    segment: customer.segment,
    priority: customer.priorityTier,
    escalated: i % 9 === 0 && status !== "closed",
    closureReason:
      status === "closed"
        ? ["Paid in full", "Settled", "Payment plan completed", "Written off"][i % 4]
        : null,
    closedAt,
  };
});

const PAYMENT_METHODS = [
  "Mobile Money",
  "Bank transfer",
  "Partial payment",
  "Instalment",
  "Card",
];

const PAYMENT_COMMENT_PRESETS = [
  "Customer confirmed",
  "Partial recovery",
  "Hardship noted",
  "Promise kept",
  "Agent assisted",
];

export const MOCK_PAYMENTS = Array.from({ length: 52 }, (_, i) => {
  const customer = MOCK_CUSTOMERS[i % MOCK_CUSTOMERS.length];
  const presets = i % 3 === 0 ? [PAYMENT_COMMENT_PRESETS[i % PAYMENT_COMMENT_PRESETS.length]] : [];
  const freeText =
    i % 4 === 0
      ? "Paid after outbound follow-up; customer requested SMS receipt."
      : i % 5 === 0
        ? "MoMo prompt completed same day."
        : "";
  return {
    id: `PY-${5000 + i}`,
    customer: customer.name,
    caseId: `RC-${8800 + (i % 38)}`,
    amount: Math.round(500 + (i * 421) % 8000),
    amountOwed: customer.amountOwed,
    amountPaid: customer.amountPaid,
    outstandingAmount: Math.max(0, customer.amountOwed - customer.amountPaid),
    method: PAYMENT_METHODS[i % PAYMENT_METHODS.length],
    paymentType: ["Full payment", "Partial payment", "Scheduled", "Instalment"][i % 4],
    status: i % 7 === 0 ? "pending" : "completed",
    receivedAt: `2026-02-${String(27 - (i % 25)).padStart(2, "0")} ${String(8 + (i % 10)).padStart(2, "0")}:${String((i * 7) % 60).padStart(2, "0")}`,
    reference: `REF-${20260200 + i}`,
    reconciled: i % 9 !== 0,
    commentPresets: presets,
    comment: freeText,
  };
});

export const MOCK_COMMUNICATIONS = Array.from({ length: 28 }, (_, i) => ({
  id: `CM-${7000 + i}`,
  customer: MOCK_CUSTOMERS[i % MOCK_CUSTOMERS.length].name,
  caseId: `RC-${8800 + (i % 38)}`,
  channel: ["SMS", "WhatsApp", "Email", "Phone call"][i % 4],
  template: [
    "Payment reminder",
    "Due date notice",
    "Payment link",
    "Legal notice",
    "Payment plan offer",
  ][i % 5],
  status: i % 6 === 0 ? "failed" : i % 4 === 0 ? "pending" : "delivered",
  sentAt: `2026-02-${String(27 - (i % 20)).padStart(2, "0")} ${String(7 + (i % 12)).padStart(2, "0")}:00`,
  response: i % 3 === 0 ? "Opened" : i % 5 === 0 ? "Paid via link" : "—",
}));

export const MOCK_PAYMENT_PLANS = Array.from({ length: 18 }, (_, i) => {
  const customer = MOCK_CUSTOMERS[i % MOCK_CUSTOMERS.length];
  const totalAmount = customer.amountOwed + customer.amountPaid;
  const instalments = 3 + (i % 4);
  const instalmentAmount = Math.round(800 + (i * 200) % 3000);
  const paidInstalments = i % 5;
  const amountPaid = Math.min(totalAmount, paidInstalments * instalmentAmount);
  const amountOwed = Math.max(0, totalAmount - amountPaid);

  return {
    id: `PP-${6000 + i}`,
    caseId: `RC-${8800 + (i % 38)}`,
    customer: customer.name,
    totalAmount,
    amountOwed,
    amountPaid,
    instalmentAmount,
    instalments,
    paidInstalments,
    nextDue: `2026-03-${String(5 + (i % 20)).padStart(2, "0")}`,
    status: i % 6 === 0 ? "broken" : i % 4 === 0 ? "completed" : "active",
    createdBy: ["Grace Mensah", "Samuel Tetteh", "Auto system"][i % 3],
  };
});

export const MOCK_PROMISES_TO_PAY = Array.from({ length: 22 }, (_, i) => ({
  id: `PTP-${4000 + i}`,
  caseId: `RC-${8800 + (i % 38)}`,
  customer: MOCK_CUSTOMERS[i % MOCK_CUSTOMERS.length].name,
  amount: Math.round(1000 + (i * 350) % 5000),
  dueDate: `2026-03-${String(1 + (i % 15)).padStart(2, "0")}`,
  status: i % 5 === 0 ? "broken" : i % 3 === 0 ? "kept" : "pending",
  recordedBy: ["Grace Mensah", "Samuel Tetteh"][i % 2],
  recordedAt: `2026-02-${String(20 + (i % 7)).padStart(2, "0")}`,
}));

export const MOCK_CONTACT_LOGS = Array.from({ length: 24 }, (_, i) => {
  const customer = MOCK_CUSTOMERS[i % MOCK_CUSTOMERS.length];
  const outcome = [
    "Promise to pay recorded",
    "Payment plan agreed",
    "No answer",
    "Customer educated",
    "Partial payment taken",
  ][i % 5];

  return {
    id: `CL-${8000 + i}`,
    caseId: `RC-${8800 + (i % 38)}`,
    customer: customer.name,
    agent: ["Grace Mensah", "Samuel Tetteh"][i % 2],
    type: ["Outbound call", "Inbound call", "Callback"][i % 3],
    duration: `${2 + (i % 8)} min`,
    outcome,
    outcomeDetails: buildContactOutcomeDetails(outcome, i, customer),
    loggedAt: `2026-02-${String(27 - (i % 15)).padStart(2, "0")} ${String(9 + (i % 8)).padStart(2, "0")}:30`,
  };
});

function buildContactOutcomeDetails(outcome, i, customer) {
  const planTotal = Math.round(customer.amountOwed * (0.85 + (i % 3) * 0.05));
  const instalments = 3 + (i % 4);
  const instalmentAmount = Math.round(planTotal / instalments);
  const promisedAmount = Math.round(800 + (i * 317) % 6000);
  const partialPaid = Math.round(promisedAmount * (0.4 + (i % 4) * 0.15));

  switch (outcome) {
    case "Payment plan agreed":
      return {
        summary: "Customer agreed to a structured repayment plan to clear the outstanding balance.",
        agentNotes:
          "Verified preferred payment channel and confirmed they understand missed instalments may trigger escalation.",
        fields: [
          { label: "Plan total", value: formatCurrency(planTotal) },
          { label: "Instalments", value: `${instalments} monthly payments` },
          { label: "Instalment amount", value: formatCurrency(instalmentAmount) },
          { label: "Start date", value: formatDate(`2026-03-${String(1 + (i % 5)).padStart(2, "0")}`) },
          { label: "First due date", value: formatDate(`2026-03-${String(10 + (i % 10)).padStart(2, "0")}`) },
          { label: "Payment method", value: ["Mobile Money", "Bank transfer", "Card"][i % 3] },
          { label: "Plan reference", value: `PP-${9100 + i}` },
          { label: "Created by", value: ["Grace Mensah", "Samuel Tetteh"][i % 2] },
        ],
        followUp: "Reminder SMS scheduled 2 days before each instalment due date.",
      };
    case "Promise to pay recorded":
      return {
        summary: "Customer committed to make a one-off payment by the agreed date.",
        agentNotes: "Customer requested confirmation SMS with payment instructions.",
        fields: [
          { label: "Promised amount", value: formatCurrency(promisedAmount) },
          { label: "Due date", value: formatDate(`2026-03-${String(5 + (i % 12)).padStart(2, "0")}`) },
          { label: "Payment method", value: ["Mobile Money", "Bank branch", "Card"][i % 3] },
          { label: "Confidence", value: ["High", "Medium", "Medium", "Low"][i % 4] },
          { label: "PTP reference", value: `PTP-${7200 + i}` },
          { label: "Recorded by", value: ["Grace Mensah", "Samuel Tetteh"][i % 2] },
        ],
        followUp: "Follow-up call scheduled if payment is not received by due date.",
      };
    case "Partial payment taken":
      return {
        summary: "Customer made a partial payment during the call.",
        agentNotes: "Payment confirmed on institution API. Balance remains on the recovery case.",
        fields: [
          { label: "Amount paid", value: formatCurrency(partialPaid) },
          { label: "Payment method", value: ["Mobile Money", "Bank transfer", "Card"][i % 3] },
          { label: "Transaction reference", value: `REF-${20260200 + i}` },
          { label: "Remaining balance", value: formatCurrency(Math.max(0, customer.amountOwed - partialPaid)) },
          { label: "Receipt sent via", value: ["SMS", "WhatsApp", "Email"][i % 3] },
          { label: "Payment logged at", value: formatDate(`2026-02-${String(20 + (i % 7)).padStart(2, "0")}`) },
        ],
        followUp: "Agent agreed to call back in 7 days to discuss clearing the remaining balance.",
      };
    case "Customer educated":
      return {
        summary: "Customer was walked through repayment options and consequences of non-payment.",
        agentNotes: "Customer acknowledged understanding. No payment commitment captured on this call.",
        fields: [
          {
            label: "Topics covered",
            value: "Repayment options · Instalment plans · Online payment · Late payment impact",
          },
          { label: "Materials sent", value: ["Payment link via SMS", "FAQ via WhatsApp", "Email summary"][i % 3] },
          { label: "Language", value: ["English", "Twi", "Ga"][i % 3] },
          { label: "Customer response", value: ["Cooperative", "Neutral", "Requested callback"][i % 3] },
          { label: "Next review date", value: formatDate(`2026-03-${String(8 + (i % 10)).padStart(2, "0")}`) },
        ],
        followUp: "Nurture SMS sequence continues unless customer opts out.",
      };
    case "No answer":
      return {
        summary: "Call attempt did not reach the customer.",
        agentNotes: i % 2 === 0 ? "Voicemail left with callback number." : "No voicemail — line rang out.",
        fields: [
          { label: "Attempt number", value: `${1 + (i % 4)} of 4` },
          { label: "Ring duration", value: `${15 + (i % 30)} seconds` },
          { label: "Voicemail", value: i % 2 === 0 ? "Yes" : "No" },
          { label: "Callback scheduled", value: formatDate(`2026-02-${String(28 + (i % 3)).padStart(2, "0")}`) },
          { label: "Next channel", value: ["SMS reminder", "WhatsApp", "Email"][i % 3] },
          { label: "Number dialled", value: customer.phone },
        ],
        followUp: "Auto SMS sent 30 minutes after unsuccessful attempt.",
      };
    default:
      return {
        summary: "Contact outcome recorded by SimCollect.",
        agentNotes: "",
        fields: [],
        followUp: null,
      };
  }
}

export const MOCK_ESCALATIONS = Array.from({ length: 14 }, (_, i) => {
  const customer = MOCK_CUSTOMERS[i % MOCK_CUSTOMERS.length];
  return {
    id: `ES-${9000 + i}`,
    caseId: `RC-${8800 + (i % 38)}`,
    customer: customer.name,
    amountOwed: customer.amountOwed,
    amountPaid: customer.amountPaid,
    amount: customer.amountOwed,
    daysOverdue: customer.daysOverdue,
    reason: [
      "90+ days overdue",
      "Broken payment plan",
      "Broken promise to pay",
      "High balance threshold",
      "Repeated non-response",
    ][i % 5],
    legalStatus: ["Pending review", "Under legal review", "Court filing", "Closed"][i % 4],
    assignedCounsel: i % 3 === 0 ? "—" : "Mensah & Associates",
    escalatedAt: `2026-02-${String(10 + (i % 15)).padStart(2, "0")}`,
    region: customer.region,
  };
});

export const MOCK_USSD_SESSIONS = [];

export const MOCK_ASSIGNMENT_RULES = [
  { id: "AR-01", name: "High value accounts", criteria: "Outstanding > ₵ 20,000", assignTo: "Grace Mensah", active: true, casesMatched: 24 },
  { id: "AR-02", name: "Greater Accra region", criteria: "Region = Greater Accra", assignTo: "Samuel Tetteh", active: true, casesMatched: 18 },
  { id: "AR-03", name: "90+ days overdue", criteria: "Days overdue ≥ 90", assignTo: "Escalation queue", active: true, casesMatched: 12 },
  { id: "AR-04", name: "Early-stage follow-up", criteria: "1–30 days overdue", assignTo: "Efua Adom", active: true, casesMatched: 86 },
  { id: "AR-05", name: "Mid-stage workload balance", criteria: "31–60 days · round robin", assignTo: "Collections desk", active: false, casesMatched: 0 },
];

export const MOCK_SEGMENT_SUMMARY = SEGMENTS.map((name, i) => ({
  name,
  accounts: [142, 98, 76, 54, 38, 22][i],
  amountOwed: [420000, 380000, 510000, 680000, 920000, 340000][i],
  amountPaid: [120000, 95000, 140000, 88000, 210000, 45000][i],
  outstanding: [420000, 380000, 510000, 680000, 920000, 340000][i],
  avgDaysOverdue: [18, 45, 72, 118, 52, 95][i],
}));

export const MOCK_REPORTS = [
  { id: "RP-01", name: "Monthly collection summary", type: "Collections", period: "Feb 2026", generatedAt: "2026-02-26", status: "completed", format: "PDF", sizeKb: 842 },
  { id: "RP-02", name: "Portfolio aging report", type: "Portfolio", period: "Feb 2026", generatedAt: "2026-02-25", status: "completed", format: "Excel", sizeKb: 1240 },
  { id: "RP-03", name: "Payment method breakdown", type: "Payments", period: "Jan 2026", generatedAt: "2026-02-01", status: "completed", format: "PDF", sizeKb: 516 },
  { id: "RP-04", name: "Collections by region", type: "Collections", period: "Q4 2025", generatedAt: "2026-01-05", status: "completed", format: "PDF", sizeKb: 688 },
  { id: "RP-05", name: "Customer contact log export", type: "Operations", period: "Feb 2026", generatedAt: "2026-02-20", status: "processing", format: "Excel", sizeKb: null },
  { id: "RP-06", name: "Collector performance report", type: "Operations", period: "Feb 2026", generatedAt: "2026-02-24", status: "completed", format: "Excel", sizeKb: 956 },
  { id: "RP-07", name: "Engagement & channel ROI", type: "Communications", period: "Feb 2026", generatedAt: "2026-02-23", status: "completed", format: "PDF", sizeKb: 724 },
  { id: "RP-08", name: "Promise to pay & payment plans", type: "Operations", period: "Feb 2026", generatedAt: "2026-02-22", status: "completed", format: "PDF", sizeKb: 612 },
  { id: "RP-09", name: "Escalation & legal summary", type: "Legal", period: "Feb 2026", generatedAt: "2026-02-21", status: "completed", format: "PDF", sizeKb: 448 },
  { id: "RP-10", name: "Payment reconciliation report", type: "Payments", period: "Feb 2026", generatedAt: "2026-02-20", status: "completed", format: "Excel", sizeKb: 1088 },
  { id: "RP-11", name: "Case closure audit", type: "Operations", period: "Feb 2026", generatedAt: "2026-02-19", status: "completed", format: "PDF", sizeKb: 532 },
];

export const MOCK_SETTLEMENTS = Array.from({ length: 28 }, (_, i) => {
  const customer = MOCK_CUSTOMERS[i % MOCK_CUSTOMERS.length];
  const outstanding = customer.amountOwed;
  const types = ["Partial settlement", "Hardship write-off", "Full settlement discount"];
  const type = types[i % 3];
  const discountPct =
    type === "Hardship write-off" ? 0.35 + (i % 3) * 0.1 : type === "Partial settlement" ? 0.15 + (i % 4) * 0.05 : 0.08;
  const proposedAmount = Math.round(outstanding * (1 - discountPct));
  const status = i % 7 === 0 ? "pending" : i % 11 === 0 ? "rejected" : i % 5 === 0 ? "completed" : "approved";

  return {
    id: `ST-${5000 + i}`,
    caseId: `RC-${8800 + (i % 38)}`,
    customer: customer.name,
    type,
    outstanding,
    proposedAmount,
    discount: outstanding - proposedAmount,
    discountPct: Math.round(discountPct * 100),
    reason: ["Financial hardship", "Job loss", "Medical expenses", "Lump sum offer", "Long-term non-payment"][i % 5],
    status,
    submittedBy: ["Grace Mensah", "Samuel Tetteh", "Collections manager"][i % 3],
    submittedAt: `2026-02-${String(10 + (i % 17)).padStart(2, "0")}`,
    reviewedAt: status === "pending" ? null : `2026-02-${String(15 + (i % 12)).padStart(2, "0")}`,
    rejectionReason:
      status === "rejected"
        ? [
            "Discount exceeds policy threshold",
            "Insufficient hardship documentation",
            "Customer not eligible for write-off",
            "Counter-offer required",
          ][i % 4]
        : null,
    institutionNotes:
      status === "rejected"
        ? [
            "Discount exceeds policy threshold. Maximum approved waiver for this segment is 25%.",
            "Insufficient hardship documentation. Request payslips or medical bills before resubmitting.",
            "Customer not eligible for write-off under current institutional policy.",
            "Counter-offer required. Institution willing to accept 82% recovery — please resubmit.",
          ][i % 4]
        : status === "approved"
          ? "Approved per institutional hardship policy section 4.2."
          : null,
    notes:
      "Customer submitted hardship documentation. SimCollect recommends review against institutional write-off policy.",
  };
});

export const MOCK_USERS = [
  {
    id: "U-01",
    name: "Acme Rural Bank",
    email: "finance@acmebank.gh",
    role: "Institution admin",
    status: "active",
    lastLogin: "2026-02-27 11:04",
    joinedAt: "2025-06-01",
    twoFactor: true,
  },
  {
    id: "U-02",
    name: "Grace Mensah",
    email: "grace.m@acmebank.gh",
    role: "Collections manager",
    status: "active",
    lastLogin: "2026-02-27 09:30",
    joinedAt: "2025-08-12",
    twoFactor: true,
  },
  {
    id: "U-03",
    name: "Samuel Tetteh",
    email: "samuel.t@acmebank.gh",
    role: "Analyst",
    status: "active",
    lastLogin: "2026-02-26 16:12",
    joinedAt: "2025-11-03",
    twoFactor: false,
  },
  {
    id: "U-04",
    name: "Diana Owusu",
    email: "diana.o@acmebank.gh",
    role: "Viewer",
    status: "active",
    lastLogin: "2026-02-25 14:00",
    joinedAt: "2026-01-15",
    twoFactor: false,
  },
  {
    id: "U-05",
    name: "Kwame Asante",
    email: "kwame.a@acmebank.gh",
    role: "Analyst",
    status: "invited",
    lastLogin: null,
    joinedAt: "2026-02-24",
    twoFactor: false,
  },
  {
    id: "U-06",
    name: "Efua Boateng",
    email: "efua.b@acmebank.gh",
    role: "Viewer",
    status: "suspended",
    lastLogin: "2026-01-10 08:22",
    joinedAt: "2025-09-20",
    twoFactor: true,
  },
];

export const WORKFLOW_KPIS = {
  collectedThisPeriod: 840200,
  outstandingTotal: 2840000,
  activeAccounts: 1122,
  validationPassRate: 97.8,
  casesCreated: 732,
  unassignedCases: 8,
  messagesSentToday: 156,
  debtorsContactedThisPeriod: 428,
  agreedToPayCount: 67,
  activeRecoveryCases: 685,
  ptpKeepRate: 89,
  reconciliationRate: 91.4,
  settlementApprovalRate: 78.5,
  settlementsPending: 6,
  escalatedCases: 14,
  casesClosedThisMonth: 47,
  paymentPlansActive: 14,
};

export function formatCurrency(amount) {
  const n = Number(amount);
  if (amount == null || Number.isNaN(n)) return "—";
  const cents = Number(n.toFixed(2));
  if (Math.abs(cents) >= 1_000_000) {
    const millions = cents / 1_000_000;
    return Number.isInteger(millions)
      ? `₵ ${millions.toLocaleString()}M`
      : `₵ ${millions.toFixed(2)}M`;
  }
  const text = cents.toFixed(2);
  if (text.endsWith(".00")) {
    return `₵ ${Math.trunc(cents).toLocaleString()}`;
  }
  return `₵ ${cents.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

/** Normalize any monetary input (number or pre-formatted string) for display. */
export function formatMoneyValue(value) {
  if (value == null || value === "" || value === "—") return "—";
  if (typeof value === "number" && !Number.isNaN(value)) return formatCurrency(value);
  if (typeof value === "string") {
    const stripped = value.replace(/[₵GHS\s]/gi, "").replace(/,/g, "");
    const n = Number(stripped);
    if (!Number.isNaN(n) && /\d/.test(stripped)) return formatCurrency(n);
    return value;
  }
  const n = Number(value);
  return Number.isNaN(n) ? "—" : formatCurrency(n);
}

export function formatDate(dateStr) {
  if (!dateStr) return "—";
  return new Date(dateStr).toLocaleDateString("en-GH", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
}

export function formatDateTime(dateStr) {
  if (!dateStr) return "—";
  const d = new Date(dateStr);
  if (Number.isNaN(d.getTime())) return String(dateStr);
  return d.toLocaleString("en-GH", {
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function formatPercent(value) {
  return `${Number(value).toFixed(1)}%`;
}
